import { useNavigate } from "react-router-dom";
import { useCallback, useMemo } from "react";

export function useAuth() {
  const navigate = useNavigate();

  const token = useMemo(() => {
    return localStorage.getItem("bigBearJWTToken");
  }, []);

  const isAuthenticated = Boolean(token);

  const logout = useCallback(() => {
    localStorage.removeItem("bigBearJWTToken");
    navigate("/login");
  }, [navigate]);

  return {
    token,
    isAuthenticated,
    logout,
  };
}
